export default __webpack_public_path__ + "static/media/2.72506fe7.jpg";